// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__ofeFi","primary":"Button_primary__dQH6j","secondary":"Button_secondary__zC+XT","onDark":"Button_onDark__icwne","small":"Button_small__7LWfm"};